import { values, keyBy, sortBy, set, get } from 'lodash';
import moment from 'moment';
import * as types from '../constants';
import { cloneState } from '../utils/stateUtils';
import { calculateIssueStations } from '../utils/permitUtils';
import { OVERNIGHT_PERMIT, calculateEntrancesExits, isExitingMtWhitney, convertOvernightCampsites } from '../utils/inyoUtils';

const INITIALSTATE = {
  agg_season_rules: [],
  permitType: OVERNIGHT_PERMIT,
  permitDate: moment().format(types.AVAILABILITY_KEY_MAP_FORMAT),
  activeTab: 0,
  divisionSearchCriteria: {
    searchText: '',
    areas: [],
    motorSize: null
  },
  questionnaire: {
    contactAgency: null
  },
  selectedDivision: null,
  selectedStartDate: null,
  selectedEndDate: null,
  selectedDivision2: null,
  selectedStartDate2: null,
  selectedEndDate2: null,
  lotteries: [],
  permit: {
    result: {
      divisions: {},
      equipments: [],
      entrances: []
    },
    divisions: [],
    recareas: [],
    recarea: [],
    entrancesExits: {},
    availability: {},
    availabilities: {},
    venue_availabilities: {},
    cooperators: [],
    cooperator: null,
    issuance: {
      division_id: "",
      permit_holder: {
        first_name: "",
        last_name: "",
        email: "",
        phone: ""
      },
      permit_holder_address: {
        postal_code: "",
        street_address1: "",
        state_code: "",
        city: ""
      }
    },
    campsites: [],
    entryCampsites: [],
    overnightCampsites: [],
    validIssueStations: []
  },
  areas: {
    list: []
  }
};

const createAndReduceIssuanceObj = (state, permit, issuance) => {
  const st = cloneState(state);
  const { entrances } = permit;
  set(issuance, 'group_size', get(issuance, 'group_info.length', 1));
  set(issuance, 'selected_group_size', get(issuance, 'group_size', 1));
  st.permit.entrancesExits = calculateEntrancesExits(entrances, issuance.division_id, permit.divisions, isExitingMtWhitney(issuance))
  st.permit = { ...st.permit, ...calculateIssueStations(entrances) };
  const { validIssueStations } = st.permit;
  if (validIssueStations.length === 1) {
    set(issuance, 'pickup_location_id', get(validIssueStations, '[0].id', ''));
  }
  st.permit.overnightCampsites = convertOvernightCampsites(issuance.campsite_preferences);
  st.permit.issuance = issuance;
  delete st.permit.fetch_err;
  return st;
}

export default function permitReducer(state = INITIALSTATE, action) {
  let st = Object.assign({}, state);

  switch (action.type) {
    case types.GET_PERMIT:
      st = cloneState(state);
      st.permit.result = action.payload;
      delete st.permit.fetch_err;
      return st;

    case types.GET_PERMIT_ERROR:
      st = cloneState(state);
      st.permit.fetch_err = action.error;
      return st;

    case types.GET_AGGREGATE_SEASON_RULES:
      st = cloneState(state);
      st.agg_season_rules = action.payload;
      delete st.agg_season_rules_err;
      return st;

    case types.GET_AGGREGATE_SEASON_ERROR:
      st = cloneState(state);
      st.agg_season_rules_err = action.error;
      return st;

    case types.GET_LOTTERY:
      st = cloneState(state);
      st.lottery = action.payload;
      delete st.permit.lottery_err;
      return st;

    case types.GET_LOTTERY_ERROR:
      st = cloneState(state);
      st.permit.lottery_err = action.error;
      return st;

    case types.GET_COOPERATORS:
      st = cloneState(state);
      st.permit.cooperators = action.payload;
      delete st.permit.cooperators_err;
      return st;

    case types.GET_COOPERATORS_ERROR:
      st = cloneState(state);
      st.permit.cooperators_err = action.error;
      return st;

    case types.GET_COOPERATOR:
      st = cloneState(state);
      st.permit.cooperator = action.payload;
      delete st.permit.cooperator_err;
      return st;

    case types.GET_COOPERATOR_ERROR:
      st = cloneState(state);
      st.permit.cooperator_err = action.error;
      return st;

    case types.GET_ISSUANCE:
      {
        const { permit, issuance } = action.payload;
        return createAndReduceIssuanceObj(state, permit, issuance);
      }
    case types.GET_ISSUANCE_ERROR:
      st = cloneState(state);
      st.permit.fetch_err = action.error;
      st.permit.fetch_issuance_error = action.error;
      return st;

    case types.GET_ISSUANCE_BY_STATUS:
      st = cloneState(state);
      if (st.permit.issuances === undefined) {
        st.permit.issuances = action.payload;
      }
      else {
        st.permit.issuances = Object.assign({}, action.payload, state.permit.issuances);
      }
      delete st.permit.fetch_err;
      return st;

    case types.GET_ISSUANCE_BY_STATUS_ERROR:
      st = cloneState(state);
      st.permit.fetch_err = action.error;
      return st;

    case types.POST_ISSUANCE:
      {
        const issuance = action.payload;
        const permit = { ...state.permit.result };
        return createAndReduceIssuanceObj(state, permit, issuance);
      }
    case types.ISSUANCE_UPDATE_INPROGRESS:
      st = cloneState(state);
      st.permit.issuance.post_in_progress = true;
      delete st.permit.error;
      return st;

    case types.POST_ISSUANCE_ERROR:
      st = cloneState(state);
      delete st.permit.issuance.post_in_progress;
      st.permit.error = action.error;
      return st;

    case types.CLEAR_ISSUANCE:
      st = cloneState(state);
      delete st.permit.issuance;
      return st;

    case types.INPROGRESS_ISSUANCE_UPDATED:
      st = { ...state };
      st.permit.issuance = action.payload
      return st;

    case types.CLEAR_IW_FETCH_ISSUANCE_ERROR:
      delete st.permit.fetch_issuance_error;
      return st;

    case types.SEND_CURRENT_DATE:
      st = cloneState(state);
      st.permit.current_date = action.payload;
      return st;

    case types.GET_AVAILABILITY:
      st = cloneState(state);
      if (st.permit.availabilities === undefined) {
        st.permit.availabilities = {};
      }
      st.permit.availabilities[action.keyName] = {
        error: undefined,
        result: action.payload
      };
      st.permit.availabilities.next_available_date = action.payload.next_available_date;
      delete st.permit.availability_err;
      return st;

    case types.GET_AVAILABILITY_ONE_DIVISION:
      st = cloneState(state);
      st.permit.venue_availabilities = Object.assign(
        {},
        st.permit.venue_availabilities,
        {
          [action.keyName]: {
            error: undefined,
            permitId: action.permitId,
            divisionId: action.divisionId,
            result: action.payload
          }
        }
      );
      st.permit.availability = action.payload;
      delete st.availability_err;
      return st;

    case types.GET_ALL_AVAILABILITIES:
      st = cloneState(state);
      if (st.permit.availabilities === undefined) {
        st.permit.availabilities = {};
      }
      st.permit.availabilities[action.keyName] = {
        result: action.payload
      };
      st.permit.availabilities.next_available_date = action.payload.next_available_date;
      delete st.availability_err;
      return st;

    case types.GET_AVAILABILITY_ERROR:
      st = cloneState(state);
      if (st.permit.availabilities === undefined) {
        st.permit.availabilities = [];
      }
      st.permit.availabilities = Object.assign({}, st.permit.availabilities, {
        [action.keyName]: {
          error: action.error,
          result: undefined
        }
      });
      st.permit.availability_err = action.error;
      delete st.permit.availability;
      return st;

    case types.GET_ALL_AVAILABILITIES_ERROR:
      st = cloneState(state);
      st.availability_err = action.error;
      delete st.availabilities;
      return st;

    case types.CLEAR_AVAILABILITIES:
      st = cloneState(state);
      if (st.permit.availabilities === undefined) {
        st.permit.availabilities = [];
      }
      st.permit.availabilities = Object.assign({});
      return st;

    case types.SAVE_FILTERS:
      st = cloneState(state);
      st.permit.filters = action.payload;
      return st;

    case types.GET_RECAREA:
      st = cloneState(state);
      st.permit.recarea = action.payload;
      delete st.permit.recarea_err;
      return st;

    case types.GET_RECAREA_ERROR:
      st = cloneState(state);
      st.permit.recarea_err = action.payload;
      return st;

    case types.GET_CART:
      st = cloneState(state);
      st.permit.cart = action.payload;
      delete st.permit.cart_err;
      return st;

    case types.GET_CART_ERROR:
      st = cloneState(state);
      st.permit.cart_err = action.payload;
      return st;

    case types.NOTIFY_LOTTERY_RESULTS:
      st = cloneState(state);
      st.permit.notify = action.payload;
      delete st.permit.notify_err;
      return st;

    case types.NOTIFY_LOTTERY_RESULTS_ERROR:
      st = cloneState(state);
      st.notify_err = action.payload;
      return st;

    case types.POST_LOTTERY:
      st = cloneState(state);
      st.permit.lottery = action.payload;
      delete st.permit.lottery_err;
      return st;

    case types.POST_LOTTERY_ERROR:
      st = cloneState(state);
      st.permit.lottery_err = action.payload;
      return st;

    case types.GET_LOTTERIES:
      st = cloneState(state);
      st.lotteries = action.payload;
      delete st.permit.lotteries_err;
      return st;

    case types.GET_LOTTERIES_ERROR:
      st = cloneState(state)
      st.lotteries_err = action.error;
      return st;

    case types.GET_ISSUANCE_PDF_ERROR:
      st = cloneState(state);
      st.permit.fetch_err = action.error;
      return st;

    case types.GET_CAMPSITES:
      st = cloneState(state);
      st.permit.campsites = action.payload;
      delete st.permit.campsites_err;
      return st;

    case types.GET_CAMPSITES_ERROR:
      st = cloneState(state);
      st.permit.campsites_err = action.payload;
      return st;

    case types.GET_DIVISION_CAMPSITES:
      st = cloneState(state);
      st.permit.entryCampsites = action.payload;
      delete st.permit.entry_campsites_err;
      return st;

    case types.GET_DIVISION_CAMPSITES_ERROR:
      st = cloneState(state);
      st.permit.entry_campsites_err = action.payload;
      return st;

    case types.POST_ISSUANCE_CALCULATE_FEES:
      st = cloneState(state);
      st.permit.issuance_fee_difference = action.payload;
      return st;

    case types.POST_ISSUANCE_CALCULATE_FEES_ERROR:
      st = cloneState(state);
      st.permit.issuance_fee_difference_err = action.error;
      return st;

    case types.POST_ISSUANCE_CARTLESS:
      {
        const { permit, issuance } = action.payload;
        return createAndReduceIssuanceObj(state, permit, issuance);
      }
    case types.POST_ISSUANCE_CARTLESS_ERROR:
      st = cloneState(state);
      st.permit.error = action.error;
      return st;

    case types.GET_USER_ISSUANCES:
      st = cloneState(state);
      st.permit.user_issuances = action.payload;
      delete st.permit.user_issuances_error;
      return st;

    case types.GET_USER_ISSUANCES_ERROR:
      st = cloneState(state);
      st.permit.user_issuances_error = action.error;
      delete st.permit.user_issuances;
      return st;

    case types.SET_PERMIT_TYPE:
      st = cloneState(state);
      st.permitType = action.permitType;
      return st;

    case types.SET_PERMIT_DATE:
      st = cloneState(state);
      st.permitDate = action.permitDate;
      return st;

    case types.SET_SELECTED_DIVISION:
      st = cloneState(state);
      st.selectedDivision = action.division;
      return st;

    case types.SET_SELECTED_START_DATE:
      st = cloneState(state);
      st.selectedStartDate = action.date;
      return st;

    case types.SET_SELECTED_END_DATE:
      st = cloneState(state);
      st.selectedEndDate = action.date;
      return st;

    case types.SET_SELECTED_DIVISION2:
      st = cloneState(state);
      st.selectedDivision2 = action.division;
      return st;

    case types.SET_SELECTED_START_DATE2:
      st = cloneState(state);
      st.selectedStartDate2 = action.date;
      return st;

    case types.SET_SELECTED_END_DATE2:
      st = cloneState(state);
      st.selectedEndDate2 = action.date;
      return st;

    case types.SET_QUESTIONNAIRE_ANSWERS:
      st = cloneState(state);
      st.questionnaire = Object.assign({}, st.questionnaire, action.answers);
      return st;

    case types.SET_ACTIVE_TAB:
      st = cloneState(state);
      st.activeTab = action.activeTab;
      return st;

    case types.SET_DIV_SEARCH_CRITERIA:
      st = cloneState(state);
      st.divisionSearchCriteria = action.divisionSearchCriteria;
      return st;
    case types.SET_DISTRICTS:
      st = cloneState(state);
      st.areas.list = action.payload;
      return st;

    case types.SET_OVERNIGHT_CAMPSITE:
      {
        st = cloneState(state);
        const { overnightCampsites } = st.permit;
        const convertedCampsites = overnightCampsites.map((oc) => ({...oc, date: moment.utc(oc.date).toJSON()}));
        const overnightCampsitesHash = keyBy(convertedCampsites, 'date');
        const { date, name } = action.payload;
        overnightCampsitesHash[date] = { date, name };
        st.permit.overnightCampsites = sortBy(values(overnightCampsitesHash),
          (obj) => moment(obj.date).format("YYYYMMDD"));
        return st;
      }

    case types.UNSET_OVERNIGHT_CAMPSITE:
      {
        st = cloneState(state);
        const { overnightCampsites } = st.permit;
        const overnightCampsitesHash = keyBy(overnightCampsites, 'date');
        const { date } = action.payload;
        delete overnightCampsitesHash[date];
        st.permit.overnightCampsites = sortBy(values(overnightCampsitesHash),
          (obj) => moment(obj.date).format("YYYYMMDD"));
        return st;
      }

    case types.CLEAR_OVERNIGHT_CAMPSITE:
      st = cloneState(state);
      st.permit.overnightCampsites = [];
      return st;

    case types.UPDATE_ISSUANCE:
      st = cloneState(state);
      st.permit.update_issuance_result = action.payload.status;
      st.permit.updated_issuance = action.payload.issuance;
      st.permit.issuance.post_in_progress = false;
      delete st.permit.update_issuance_error;
      return st;

    case types.UPDATE_ISSUANCE_ERROR:
      st = cloneState(state);
      st.permit.update_issuance_error = action.error.error;
      delete st.permit.update_issuance_result;
      delete st.permit.updated_issuance;
      delete st.permit.issuance.post_in_progress;
      return st;

    case types.FINALIZE_CHECKOUT:
      const confirmation = {
        orderID: action.payload.order_id,
        completedReservations: action.payload.completed_reservations,
        subtotal: action.payload.subtotal,
        tax: action.payload.tax,
        total: action.payload.total,
        modification: action.payload.modification
      };
      st.permit.order_confirmation = confirmation;
      return st;

    case types.GET_ACCOUNT_EMPLOYEES:
      st = cloneState(state);
      st.account_employees = action.employees;
      delete st.get_account_employees_error;
      return st;

    case types.GET_ACCOUNT_EMPLOYEES_ERROR:
      st = cloneState(state);
      st.get_account_employees_error = action.error;
      return st;

    case types.GET_PERMIT_GALLERY:
      st = cloneState(state);
      st.permit.gallery = action.payload;
      return st;

    default:
      return st;
  }
}
